import styled, { css } from "styled-components";
import { SectionHeading } from "../Text";
import BlockContent from "../../components/BlockContent";

export const EmptyContainer = styled.div`
  padding: 12rem 5rem 0rem 5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .bold {
      font-weight: bold;
  }

  @media ${({ theme }) => theme.device.tablet} {
    padding-top: 12rem 5rem 0;
    align-items: left;
  }

  @media ${({ theme }) => theme.device.phone} {
    padding-top: 12rem;
    padding-right: 0rem;
    padding-left: 0rem;
    align-items: left;
  }
`;

export const EmptyHeading = styled(BlockContent)`
  font-family: 'Effra-Regular';

  strong {
    font-family: 'Effra-Bold';
  }
  
  h3 {
    font-family: 'Effra-Medium';
    font-size: 42px;
    line-height: 46px;
    margin-bottom: 24px;
    margin-top: 0;
    font-weight: 400;

    @media ${({ theme }) => theme.device.phone} {
      font-size: 32px;
      line-height: 34px;
    }
  }

  p {
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 24px;

    @media ${({ theme }) => theme.device.phone} {
      font-size: 16px;
      line-height: 20px;
    }
  } 
`;
